import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from './api';
// Cache lifetimes + tag invalidation for the reads every fresh load makes.
import './api/requestBudget';
// The recent practice-sessions list refreshes when a session ends/finalizes.
import './api/sessionListInvalidation';
import './api/learnInvalidation';
import { demoApi } from './api/demoApi';
import { centralAuthApi } from './api/centralAuthApi';
import centralAuthReducer, { beheardAuthExtReducer } from './slices/centralAuthSlice';
import bootContextReducer from './slices/bootContextSlice';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [demoApi.reducerPath]: demoApi.reducer,
    [centralAuthApi.reducerPath]: centralAuthApi.reducer,
    centralAuth: centralAuthReducer,
    beheardAuthExt: beheardAuthExtReducer,
    bootContext: bootContextReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      api.middleware,
      demoApi.middleware,
      centralAuthApi.middleware
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
